import Api from '@/services/Api'

export default {
  register (credentials) {
    return Api().post('register', credentials)
  },
  login (credentials) {
    return Api().post('login', credentials)
  },
  logout () {
    return Api().post('logout')
  }
}

//  AuthenicationService.register ({
//     email: 'testing@gmail.com',
//     password: '123456'
// })



// WEBPACK FOOTER //
// ./src/services/AuthenticationService.js